import {
  NAV_ITEM_TYPE_ITEM,
} from "@/constants/navigation.constant";

import type { NavigationTree } from "@/@types/navigation";

const cpAdmNavigationConfig: NavigationTree[] = [
  {
    key: "home",
    path: "/admin/_cp/home",
    title: "Home",
    translateKey: "nav.home",
    icon: "home",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [],
    subMenu: [],
  },
  {
    key: "cp_translations",
    path: "/admin/_cp/translations",
    title: "Translation",
    translateKey: "cp.translations",
    icon: "CpI18n",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [],
    subMenu: [],
  },
  {
    key: "cp_cstln_data",
    path: "/admin/_cp/cstln_data",
    title: "CSTLN DATA",
    translateKey: "cp.cstln_data",
    icon: "CpCstlnData",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [],
    subMenu: [],
  },
];

export default cpAdmNavigationConfig;
